import { DesignIcon } from '@monorepo/nova-icons';
import { Stack, useTheme } from '@monorepo/nova-ui';
import { type OptionalAssets } from '@monorepo/types';
import { type CreditCartAsset, CreditEventType } from '../credit-events.types';
import {
  StyledCreditBody,
  StyledCreditBodyGroup,
  StyledCreditContentStack,
  StyledCreditEmphasis,
  StyledCreditFootnote,
  StyledCreditsIconWrap,
  StyledCreditTitle,
  StyledCreditTitleLine,
  StyledSecondaryCreditButton,
} from '../styled';
import RedeemCreditButton from './redeem-credit-button';

interface CreditEventsContentLayoutProps {
  type: CreditEventType;
  title: string;
  titleLine2?: string;
  emphasis?: string;
  body: string;
  bodyLine2?: string;
  footnote?: string;
  redeemLabel: string;
  seeAllLabel: string;
  onRedeem: () => void;
  onSeeAllCredits: () => void;
  cartAssets?: CreditCartAsset[];
  onRedeemForAsset?: (asset: OptionalAssets) => void;
  onNewOrder?: () => void;
}

const CreditEventsContentLayout = ({
  type,
  title,
  titleLine2,
  emphasis,
  body,
  bodyLine2,
  footnote,
  redeemLabel,
  seeAllLabel,
  onRedeem,
  onSeeAllCredits,
  cartAssets,
  onRedeemForAsset,
  onNewOrder,
}: CreditEventsContentLayoutProps) => {
  const theme = useTheme();

  return (
    <StyledCreditContentStack>
      {type === CreditEventType.ReceivedCredit && (
        <StyledCreditsIconWrap>
          <DesignIcon
            useMuiSvgIcon={false}
            iconName={
              theme.palette.mode === 'light'
                ? 'CoinsContainedLight'
                : 'CoinsContainedDark'
            }
          />
        </StyledCreditsIconWrap>
      )}
      <Stack alignItems="center" spacing={4} width="100%">
        {titleLine2 ? (
          <StyledCreditTitle variant="h3" component="h2">
            <StyledCreditTitleLine>{title}</StyledCreditTitleLine>
            <StyledCreditTitleLine>{titleLine2}</StyledCreditTitleLine>
          </StyledCreditTitle>
        ) : (
          <StyledCreditTitle variant="h3" component="h2">
            {title}
          </StyledCreditTitle>
        )}

        {emphasis ? (
          <StyledCreditEmphasis component="p">{emphasis}</StyledCreditEmphasis>
        ) : null}

        {bodyLine2 ? (
          <StyledCreditBodyGroup>
            <StyledCreditBody component="p">{body}</StyledCreditBody>
            <StyledCreditBody component="p">{bodyLine2}</StyledCreditBody>
          </StyledCreditBodyGroup>
        ) : (
          <StyledCreditBody component="p">{body}</StyledCreditBody>
        )}

        {footnote ? (
          <StyledCreditFootnote component="p">{footnote}</StyledCreditFootnote>
        ) : null}
      </Stack>

      <RedeemCreditButton
        redeemLabel={redeemLabel}
        cartAssets={cartAssets}
        onRedeem={onRedeem}
        onRedeemForAsset={onRedeemForAsset}
        onNewOrder={onNewOrder}
      />

      <StyledSecondaryCreditButton onClick={onSeeAllCredits}>
        {seeAllLabel}
      </StyledSecondaryCreditButton>
    </StyledCreditContentStack>
  );
};

export default CreditEventsContentLayout;
